module.exports = __webpack_public_path__ + "img/ic_personal info.e520464a.svg";